export default __webpack_public_path__ + "static/media/Four-in-one-sensor-active_v1.567e6d90.svg";